export default "__VITE_ASSET__ac8ed380__"